import state from "@/store/modules/box-historic/state";
import actions from "@/store/modules/box-historic/actions";
import mutations from "@/store/modules/box-historic/mutations";
import getters from "@/store/modules/box-historic/getters";

export default {
    state,
    actions,
    mutations,
    getters
}